import Axios from "axios";

import { destroyToken, getToken } from "./auth/token";
import { toast } from "react-toastify";

function authRequestInterceptors(config) {
  if (config.headers) {
    config.headers.Accept = "application/json";

    // praveen remove this line, temp code
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${getToken()}`;
    }
  }

  config.withCredentials = true;
  return config;
}

export const api = Axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

api.interceptors.request.use(authRequestInterceptors);
api.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    const message = error.response?.data?.message || error.message;

    if (error.response?.status === 401) {
      destroyToken();
    }

    toast.error(message);

    return Promise.reject(error);
  }
);
